"use client";

import React, { useCallback, useRef, useState } from "react";
import styled from "styled-components";
import { default as ReactSlick } from "react-slick";
import { translateBrand, translateModel } from "@motorata/base-ui.data";
import { IconButton } from "@motorata/base-ui.components.atoms.button";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { EmptyModal } from "@motorata/base-ui.components.molecules.modal";
import Image from "../../components/common/Image";
import { arrayMinLength } from "@/utils/arrays";

// const GalleryFullScreen = ({ index, show, setShow, onNext, onPrev, images, offer }) => {
//   const ref = useRef()
//
//   const handleOnNext = useCallback(() => {
//     ref.current?.slickNext()
//   }, [])
//
//   const handleOnPrev = useCallback(() => {
//     ref.current?.slickPrev()
//   }, [])
//
//   const handleKeyPress = useCallback(
//     e => {
//       switch (e.keyCode) {
//         case 37:
//           handleOnPrev()
//           break
//         case 39:
//           handleOnNext()
//           break
//       }
//     },
//     [handleOnPrev, handleOnNext],
//   )
//
//   useEffect(() => {
//     window.addEventListener("keydown", handleKeyPress)
//
//     return () => {
//       window.removeEventListener("keydown", handleKeyPress)
//     }
//   }, [])
//
//   return (
//     <>
//       <Portal id="root-modal-background">
//         <CSSTransition in={show} timeout={200} classNames="background" unmountOnExit>
//           <Background onClick={() => {}} />
//         </CSSTransition>
//       </Portal>
//       <Portal id="root-modal-content">
//         <CSSTransition in={show} timeout={200} classNames="content" unmountOnExit>
//           <FullScreenWrapper>
//             <FullScreenContent>
//               <ReactSlick ref={ref} initialSlide={index}>
//                 {images.map((img, index) => (
//                   <Image
//                     key={index}
//                     objectFit="contain"
//                     alt={`Zdjęcie na pełny ekran oferty ${translateBrand(
//                       offer.brand,
//                     )} ${translateModel(offer.model)} nr. ${index + 1}`}
//                     src={img.src}
//                     width="1280"
//                   />
//                 ))}
//               </ReactSlick>
//             </FullScreenContent>
//             <IconButton
//               icon="arrow-left"
//               onClick={handleOnPrev}
//               style={{
//                 position: "absolute",
//                 left: 15,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//               }}
//             />
//             <IconButton
//               icon="arrow-right"
//               onClick={handleOnNext}
//               style={{
//                 position: "absolute",
//                 right: 15,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//               }}
//             />
//             <IconButton
//               icon="close"
//               onClick={() => setShow(false)}
//               style={{
//                 position: "fixed",
//                 right: 15,
//                 top: 15,
//               }}
//             />
//           </FullScreenWrapper>
//         </CSSTransition>
//       </Portal>
//     </>
//   )
// }

const OfferContentGallery = ({ id, brand, model, images: imagesProp, youtube }) => {
  const [showFullScreen, setShowFullScreen] = useState(false);

  const images = arrayMinLength(imagesProp, 7);

  const mainRef = useRef();
  const thumbnailRef = useRef();
  const fullScreenRef = useRef();

  const [index, setIndex] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const settingsFullScreen = {
    dots: false,
    infinite: true,
    arrows: false,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const settingsThumbnails = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 6,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  };

  const handleOnNext = useCallback(() => {
    // @ts-ignore
    mainRef.current?.slickNext();
    // @ts-ignore
    thumbnailRef.current?.slickNext();
    // @ts-ignore
    fullScreenRef.current?.slickNext();
    setIndex(index + 1);
  }, [index]);

  const handleOnPrev = useCallback(() => {
    // @ts-ignore
    mainRef.current?.slickPrev();
    // @ts-ignore
    thumbnailRef.current?.slickPrev();
    // @ts-ignore
    fullScreenRef.current?.slickPrev();
    setIndex(index - 1);
  }, [index]);

  const handleChangeSlide = useCallback(index => {
    // @ts-ignore
    thumbnailRef.current?.slickGoTo(index);
    // @ts-ignore
    mainRef.current?.slickGoTo(index);
    // @ts-ignore
    fullScreenRef.current?.slickGoTo(index);
    setIndex(index);
  }, []);

  return (
    <>
      <Wrapper>
        <div className="offer_gallery_main">
          <ReactSlick
            ref={mainRef}
            beforeChange={(_, newIndex) => handleChangeSlide(newIndex)}
            initialSlide={index}
            {...settings}
          >
            {
              youtube &&
              <Box width="100%" height="100%">
                <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${new URLSearchParams(`?${youtube.split("?")[1]}`).get("v")}`}
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
              </Box>
            }
            {images.map((img, index) => (
              <Image
                key={index}
                fill
                alt={`Zdjęcie oferty ${translateBrand(brand)} ${translateModel(
                  model
                )} nr. ${index + 1}`}
                src={img.src}
                size={1280}
              />
            ))}
          </ReactSlick>
          <IconButton
            size="XL"
            icon="arrow-left"
            onClick={handleOnPrev}
            style={{
              borderRadius: 3,
              position: "absolute",
              left: 15,
              top: "50%",
              transform: "translateY(-50%)"
            }}
          />
          <IconButton
            size="XL"
            icon="arrow-right"
            onClick={handleOnNext}
            style={{
              borderRadius: 3,
              position: "absolute",
              right: 15,
              top: "50%",
              transform: "translateY(-50%)"
            }}
          />
          <IconButton
            size="XL"
            icon="full-screen"
            onClick={() => setShowFullScreen(true)}
            style={{
              borderRadius: 3,
              position: "absolute",
              right: 15,
              bottom: 15,
            }}
          />
        </div>
        <div className="offer_gallery_thumbnails">
          <ReactSlick
            ref={thumbnailRef}
            beforeChange={(_, newIndex) => handleChangeSlide(newIndex)}
            initialSlide={index}
            {...settingsThumbnails}
          >
            {images.map((img, index) => (
              <div key={index} onClick={() => handleChangeSlide(youtube ? index + 1 : index)}>
                <div className="thumbnail">
                  <Image
                    priority={true}
                    fill
                    alt={`Miniaturka zdjęcia oferty ${translateBrand(brand)} ${translateModel(
                      model
                    )} nr. ${index + 1}`}
                    src={img.src}
                    size={1280}
                  />
                </div>
              </div>
            ))}
          </ReactSlick>
        </div>
      </Wrapper>
      <EmptyModal show={showFullScreen} setShow={setShowFullScreen}>
        <FullScreenContent onClick={(e) => e.stopPropagation()}>
          <ReactSlick
            ref={fullScreenRef}
            beforeChange={(_, newIndex) => handleChangeSlide(newIndex)}
            initialSlide={index}
            {...settingsFullScreen}
          >
            {
              youtube &&
              <Box width="100%" height="100%">
                <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${new URLSearchParams(`?${youtube.split("?")[1]}`).get("v")}`}
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
              </Box>
            }
            {images.map((img, index) => (
              <Image
                key={index}
                fill
                alt={`Zdjęcie oferty ${translateBrand(brand)} ${translateModel(
                  model
                )} nr. ${index + 1}`}
                src={img.src}
                size={1280}
              />
            ))}
          </ReactSlick>
          <IconButton
            size="XL"
            icon="arrow-left"
            onClick={handleOnPrev}
            style={{
              borderRadius: 3,
              position: "absolute",
              left: 15,
              top: "50%",
              transform: "translateY(-50%)"
            }}
          />
          <IconButton
            size="XL"
            icon="arrow-right"
            onClick={handleOnNext}
            style={{
              borderRadius: 3,
              position: "absolute",
              right: 15,
              top: "50%",
              transform: "translateY(-50%)"
            }}
          />
        </FullScreenContent>
      </EmptyModal>
    </>
  );
};

export default OfferContentGallery;

const FullScreenContent = styled.div`
  position: relative;
  width: 100vw;
  max-width: 1200px;
  padding-bottom: 56.25%;
  
  .slick-slider {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;

    div {
      height: 100% !important;
      position: relative;

      span {
        width: 100% !important;
        height: 100% !important;
      }

      img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
      }
    }
  }
`;

const FullScreenWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  padding: 66px 0;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
`;

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.S};

  .offer_gallery_main {
    padding-bottom: 56.25%;
    border-radius: 5px;
    position: relative;
    overflow: hidden;

    @media (max-width: 800px) {
      border-radius: 0;
    }

    .slick-slider {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;

      div {
        height: 100% !important;
        position: relative;

        span {
          width: 100% !important;
          height: 100% !important;
        }

        img {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover;
        }
      }
    }
  }

  .offer_gallery_thumbnails {
    margin-top: 5px;

    .slick-slider {
      height: 100% !important;

      .slick-list {
        //margin: 0 -15px;
      }

      .slick-slide {
        border-radius: 5px;
        overflow: hidden;
        //margin: 0 15px;
        padding: 5px;

        .thumbnail {
          width: 100%;
          padding-bottom: 100%;
          position: relative;
          border-radius: 5px;
          overflow: hidden;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
            position: absolute;
            object-fit: cover;
          }
        }
      }

      //.slick-current{
      //  border: 1px solid red;
      //}

      div {
        height: 100% !important;

        img {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover;
        }
      }
    }

    @media (max-width: 800px) {
      margin-top: 0;

      .slick-slider {
        .slick-slide {
          padding: 0;
          border-radius: 0;

          .thumbnail {
            border-radius: 0;
          }
        }
      }
    }
  }

  @media (max-width: 800px) {
    width: 100vw;
    margin-left: calc((100vw - 100%) / -2);
  }
`;
